export const CURRENT_USER_UPDATE = "CURRENT_USER_UPDATE";
export const CURRENT_USER_RESET = "CURRENT_USER_RESET";
export const CUREENT_USER_GET_ERROR = "CUREENT_USER_GET_ERROR";
export const CURRENT_USER_List_UPDATE = "CURRENT_USER_List_UPDATE";
export const CURRENT_USER_List_RESET = "CURRENT_USER_List_RESET";
export const CURRENT_USER_List_ERROR = "CURRENT_USER_List_ERROR";
export const CURRENT_ROLES_UPDATE = "CURRENT_ROLES_UPDATE";
export const CUREENT_ROLES_GET_ERROR = "CUREENT_ROLES_GET_ERROR";
export const CURRENT_SIGNUP_UPDATE = "CURRENT_SIGNUP_UPDATE";
export const CUREENT_SIGNUP_GET_ERROR = "CUREENT_SIGNUP_GET_ERROR";
